export default [
  {
    path: '/carShop/store',
    name: 'car-shop-store',
    component: () => import('@/projects/carShop/store'),
    meta: {
      title: '车店',
      index: 1,
      param: 'cityName=城市名称（可选）'
    }
  },
  {
    path: '/carShop/storeDetail',
    name: 'car-shop-store-detail',
    component: () => import('@/projects/carShop/storeDetail'),
    meta: {
      title: '店铺详情',
      index: 2,
      param: 'storeId=店铺ID'
    }
  },
  {
    path: '/carShop/goodsDetail',
    name: 'car-shop-goods-detail',
    component: () => import('@/projects/carShop/goodsDetail'),
    meta: {
      title: '商品详情',
      index: 3,
      param: 'goodsId=商品ID'
    }
  }
]



// WEBPACK FOOTER //
// ./src/projects/carShop/index.js